define([
    'text!product-detail/grocery/brand-info.html',
    'product-detail/mixin/product',

    'css!product-detail/grocery/brand-info.css'
], function(
    tpl,
    ProductMixin
){
    return {
        template: tpl,
        mixins: [ProductMixin],
        computed: {
            brandInfo: function(){
                return this.spu.brandInfo || {};
            },
            brandImage: function(){
                return this.brandInfo.brandLogo || this.brandInfo.brandImg || '';
            }
        }
    };
});


//////////////////
// WEBPACK FOOTER
// ./product-detail/grocery/brand-info.js
// module id = 301
// module chunks = 0